module.exports = __webpack_public_path__ + "img/packages/h0.397fbc.png";